import React from "react";
import Section from "../ui/Section/Section";
import { Grid } from "../ui/Grid/Grid";
import ChartCard from "../ui/Card/ChartCard";
import { CardBody, CardUnit, CardValue, CenterRow } from "../ui/Card/Card";
import Donut from "../charts/Donut";
import Legend from "../ui/Legend/Legend";
import MiniMetric from "../ui/MiniMetric/MiniMetric";
import SectionSkeleton from "../ui/SectionSkeleton/SectionSkeleton";
import { SECTIONS } from "../../constants";
import { fmt1, fmtN } from "../../functions/format";
import { CHART_COLORS } from "../../styles/theme";

const { id, title } = SECTIONS.absences;

const SKELETON_ROWS = [{ cols: 3, cards: [5, 4, 5] }];

const AbsencesSection = ({ data, isLoading }) => {
    if (isLoading && !data) {
        return (
            <Section id={id} title={title}>
                <SectionSkeleton rows={SKELETON_ROWS} />
            </Section>
        );
    }

    if (!data) return null;

    const { joursTravailles, joursAbsence, motifs } = data;
    const totalJours = joursTravailles + joursAbsence;

    return (
        <Section id={id} title={title}>
            <Grid cols={3}>
                <ChartCard title="Absences vs jours travaillés" fill>
                    <CenterRow>
                        <Donut
                            segments={
                                totalJours > 0
                                    ? [
                                          {
                                              value: joursTravailles,
                                              color: CHART_COLORS.violet,
                                              tip: `Jours travaillés : ${fmtN(
                                                  joursTravailles
                                              )} j`,
                                          },
                                          {
                                              value: joursAbsence,
                                              color: CHART_COLORS.blue,
                                              tip: `Jours d’absence : ${fmt1(
                                                  joursAbsence
                                              )} j`,
                                          },
                                      ]
                                    : [{ value: 1, color: CHART_COLORS.line }]
                            }
                            center={fmtN(totalJours)}
                            sub="JOURS"
                        />
                    </CenterRow>
                    <Legend
                        items={[
                            {
                                name: `Jours travaillés ${fmtN(
                                    joursTravailles
                                )} j`,
                                color: CHART_COLORS.violet,
                            },
                            {
                                name: `Jours d’absence ${fmt1(joursAbsence)} j`,
                                color: CHART_COLORS.blue,
                            },
                        ]}
                    />
                </ChartCard>

                <ChartCard title="Absentéisme" fill>
                    <CardBody>
                        <CardValue>
                            {fmt1(data.taux)}
                            <CardUnit>%</CardUnit>
                        </CardValue>
                    </CardBody>
                    <MiniMetric
                        mt="10px"
                        label="Durée moyenne d’absence"
                        value={`${fmt1(data.dureeMoyenne)} jours`}
                    />
                    <MiniMetric
                        label="Fréquence d’absence"
                        value={`${fmt1(data.frequence)} arr./collab.`}
                    />
                </ChartCard>

                <ChartCard title="Absences par motif" fill>
                    <CenterRow>
                        <Donut
                            segments={
                                motifs.length
                                    ? motifs.map((m) => ({
                                          value: m.value,
                                          color: m.color,
                                          tip: `${m.name} : ${fmt1(m.value)} j`,
                                      }))
                                    : [{ value: 1, color: CHART_COLORS.line }]
                            }
                            center={fmt1(joursAbsence)}
                            sub="JOURS"
                        />
                    </CenterRow>
                    <Legend
                        items={motifs.map((m) => ({
                            name: `${m.name} ${m.pct}%`,
                            color: m.color,
                        }))}
                    />
                </ChartCard>
            </Grid>
        </Section>
    );
};

export default AbsencesSection;
